import React from 'react'
import { I18nConsumer } from '../i18n-provider'
import { css, cx } from '@emotion/css'
import {
  IconAdd,
  theme
} from '@contrast-security-inc/design-system-foundations'
import { Button } from '@contrast-security-inc/design-system-buttons'

const minWidth = '1260px'

export function AddNewSensorButton({
  disabled = false,
  onClick
}: {
  readonly disabled?: boolean
  readonly onClick: React.MouseEventHandler<HTMLButtonElement>
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <I18nConsumer>
      {({ intl }) => (
        <Button
          Icon={IconAdd}
          data-testid="sensor-wizard-add-sensor-button"
          className={cx(
            css`
              ${disabled && 'cursor: not-allowed'};
              height: 34px;
              margin-top: 8px;
              width: 34px;
              padding: 0;
              align-items: center;
              @media (min-width: ${minWidth}) {
                width: auto;
                padding: 5px 10px;
              }

              background: ${theme.color.brandEmeraldGreen};
              &:hover:enabled,
              &:focus-visible:enabled {
                background: ${theme.color.brandEmeraldGreen};
                color: ${theme.color.black};
                filter: brightness(0.9);

                svg {
                  fill: ${theme.color.black};
                }
              }
            `
          )}
          onClick={onClick}
        >
          <span
            className={css`
              display: none;
              @media (min-width: ${minWidth}) {
                & {
                  display: block;
                }
              }
            `}
          >
            {intl.formatMessage({ id: 'header_addSensorWizard_addNew' })}
          </span>
        </Button>
      )}
    </I18nConsumer>
  )
}
